import { Component, ViewChild, Directive, ViewContainerRef, ElementRef, Inject, AfterViewInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ColumnPrefilter, LookupComponent } from './lookup.component';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AimsCommonTableComponent, AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'aims-lookup-popup',
    styleUrls: ['./lookup.component.css'],
    templateUrl: './lookupPopup.component.html'
})
export class LookupPopupComponent implements AfterViewInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: Observable<any>) { }

    @ViewChild('lookupTable') lookupTable: AimsCommonTableComponent;
    @ViewChild('selectBtn') selectBtn: ElementRef;
    @ViewChild('cancelBtn') cancelBtn: ElementRef;

    @Output() selectedObj: EventEmitter<any> = new EventEmitter();
    @Output() selectedVal: EventEmitter<any> = new EventEmitter();

    lookup: LookupComponent;
    values: Observable<any>;
    name: string = 'lookupPopupTable';
    _value: any;
    _selectedDataItem: any;

    //Pop-up controls
    permissions: AimsCommonTablePermissions = {
        create: false,
        update: false,
        delete: false,
    };

    columnsInGrid: AimsCommonTableHeader[] = [];
    gridText: string;
    note: string;
    imgSrc: string = environment.assetsPath;

    public gridSelectionChange(event) {
        if (event) {
            this._value = event[this.lookup.idPropertyName];
            this.select(event);
        }
    }

    select(dataItem) {
        this._selectedDataItem = dataItem;
        const selectionKey = this.lookupTable.header[0].key;
        this.lookupTable.selection[selectionKey] = new SelectionModel<any>(false, null);
        this.lookupTable.handleSelection('true', selectionKey, this._selectedDataItem);
        if(this.lookup.required){
            this.lookup.lookupClass.replace('required','');
        }
    }

    nullLookup() {
        this.lookup.writeValue(null, true);
        this.lookup.valueChangeObj.emit(null);
        if(this.lookup.required && !this.lookup.lookupClass.includes('required')){
            this.lookup.lookupClass += ' required'
        }
    }

    clickSelectBtn() {
        this.selectedVal.emit(this._value);

        //Doing this to be able to emit the full dataitem as well as the primitive id value
        this.selectedObj.emit(this._selectedDataItem);
    }

    ngAfterViewInit(){
        if (this._value && this.lookup.selectedObj) {
            this.select(this.lookup.selectedObj);
        }

         // Set initial filter//Get initial filter value if observable
        this.lookup.columnsPreFilter.forEach(cpf => {
            let col = this.lookupTable.header.filter(h => h.key == cpf.columnId)[0];
            if (cpf.preFilterValue) {
                if (cpf.preFilterValue instanceof Observable) {
                    cpf.preFilterValue.pipe(take(1)).subscribe(val => {
                        this.lookupTable.filterChange({ value: cpf.preFilterValue}, col );
                    });
                }
                else {
                    this.lookupTable.filterChange({ value: cpf.preFilterValue}, col);
                }
            }
        });
    }

    ngOnInit() {
        this.columnsInGrid = this.lookup.columnsInGrid;
        this.name = this.lookup.name;
        this.gridText = this.lookup.gridText;
        this.note = this.lookup.note;
    }
}
